/**
 * Evaluates whether a field should be visible based on its `visible_if` condition.
 * Checks `hide` flag first, then evaluates conditional visibility against sibling field values.
 */
export function isFieldVisible(field: any, allFields: Record<string, any>): boolean {
    if (field.hide) return false;

    if (field.visible_if) {
        const { field: depFieldName, value: requiredValue } = field.visible_if;
        const depField = allFields[depFieldName];
        if (!depField) return false;

        // Resolve the current value of the dependency field.
        // initEnum sets null values to the string 'null', so treat that as no value.
        let currentValue = depField.currentValue?.value;
        if (currentValue === null || currentValue === undefined || currentValue === 'null') {
            currentValue = depField.value?.value;
        }
        if (currentValue === null || currentValue === undefined || currentValue === 'null') {
            currentValue = depField.default;
        }

        if (Array.isArray(requiredValue)) {
            return requiredValue.includes(currentValue);
        }
        return currentValue === requiredValue;
    }

    return true;
}
